import type { ComponentChildren } from "preact";

// Icons drawn from the widget's branding files (`widget/src/assets/fi-*.svg`,
// Flaticon UIcons); `Icons.test.tsx` keeps each shape equal to its file. An
// icon takes the size and colour of the text around it. Without a `label` it
// is decorative; with one it is named for a screen reader, where it stands in
// for a word (a column header, a cell of its own).

interface IconProps {
  label?: string;
}

function BrandIcon({
  label,
  viewBox,
  children,
}: IconProps & { viewBox: string; children: ComponentChildren }) {
  return (
    <svg
      class="icon"
      viewBox={viewBox}
      width="1em"
      height="1em"
      fill="currentColor"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : "true"}
    >
      {children}
    </svg>
  );
}

// fi-sr-thumbs-up.svg
export function ThumbUpIcon({ label }: IconProps) {
  return (
    <BrandIcon viewBox="0 0 24 24" label={label}>
      <path d="M22.773,7.721A4.994,4.994,0,0,0,19,6H15.011l.336-2.041A3.037,3.037,0,0,0,9.626,2.122L8,5.417V21H18.3a5.024,5.024,0,0,0,4.951-4.3l.705-5A4.994,4.994,0,0,0,22.773,7.721Z" />
      <path d="M0,11v5a5.006,5.006,0,0,0,5,5H6V6H5A5.006,5.006,0,0,0,0,11Z" />
    </BrandIcon>
  );
}

// fi-sr-thumbs-down.svg
export function ThumbDownIcon({ label }: IconProps) {
  return (
    <BrandIcon viewBox="0 0 24 24" label={label}>
      <path d="M23.951,12.3l-.705-5A5.024,5.024,0,0,0,18.3,3H8V18.584l1.626,3.3a3.038,3.038,0,0,0,5.721-1.838L15.011,18H19a5,5,0,0,0,4.951-5.7Z" />
      <path d="M0,8v5a5.006,5.006,0,0,0,5,5H6V3H5A5.006,5.006,0,0,0,0,8Z" />
    </BrandIcon>
  );
}

// fi-sr-flag.svg
export function FlagIcon({ label }: IconProps) {
  return (
    <BrandIcon viewBox="0 0 24 24" label={label}>
      <path d="m1 24a1 1 0 0 1 -1-1v-19a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4v5a4 4 0 0 1 -4 4h-9v10a1 1 0 0 1 -1 1zm19-20h-3v5a6.006 6.006 0 0 1 -6 6h-.444a3.987 3.987 0 0 0 3.444 2h6a4 4 0 0 0 4-4v-5a4 4 0 0 0 -4-4z" />
    </BrandIcon>
  );
}

// fi-sr-triangle-warning.svg
export function WarningIcon({ label }: IconProps) {
  return (
    <BrandIcon viewBox="0 0 24 24" label={label}>
      <path d="M23.08,15.33L15,2.57c-.68-.98-1.81-1.57-3-1.57s-2.32,.58-3.03,1.6L.93,15.31c-1.02,1.46-1.21,3.21-.5,4.56,.7,1.35,2.17,2.12,4.01,2.12h15.12c1.85,0,3.31-.77,4.01-2.12,.7-1.35,.51-3.09-.49-4.54ZM11,7c0-.55,.45-1,1-1s1,.45,1,1v6c0,.55-.45,1-1,1s-1-.45-1-1V7Zm1,12c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Z" />
    </BrandIcon>
  );
}
